<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let cpr of form?.controls; let i = index">
    <div class="cpr-container-fields">
      <mat-form-field>
        <input
          matInput
          placeholder="Nome (CPRN)"
          formControlName="CPRN">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Indirizzo (CPRI)"
          formControlName="CPRI">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          type="date"
          placeholder="Data di scadenza (CPRD)"
          formControlName="CPRD">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Note (CPRS)"
          formControlName="CPRS">
      </mat-form-field>
      <button
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi diritto' | translate }}
  </button>
</div>
